import React, { useContext } from "react";
import ConceptoProgressBar from "../global/ConceptoProgressBar";
import { getValue } from "../../utils";
import { AppConfigContext } from "../../context/AppConfigContext";

const ProgresoPartidaChart = ({ partida, handleClick }) => {
  const appconfig = useContext(AppConfigContext);

  const real = getValue(appconfig, "progress") === "money" ?  parseInt(partida.progreso) : parseInt(partida.real * 100);
  const programado = parseInt(Number(partida.programado) * 100);

  const diff = programado - real;
  let programadoClass = "programado-gradiente";
  if (diff > 10) programadoClass = "diferencial-gradiente";
  else if (diff >= 5) programadoClass = "pagos-gradiente";

  return (
    <div className="mb-4">
      <div className="row mx-0 align-items-center">
        <div className="col-6 ps-0 ps-md-3">
          <p className="mb-0">{partida.nombre}</p>
        </div>
        <div className="col-6  text-end">
          <p className="mb-0">
            {real}% / {programado}%
          </p>{" "}
        </div>
      </div>
      <ConceptoProgressBar
        label={`${real}% / ${programado}%`}
        idPartida={partida.idPartida}
        handleClick={handleClick}
        programado={programado}
        real={real}
        programadoClass={programadoClass}
      />
    </div>
  );
};

export default ProgresoPartidaChart;
